module.exports = __webpack_public_path__ + "safari-pinned-tab.20420d30.svg";